/* @flow */

import React from 'react';
import { observer } from 'mobx-react';

import Loading from 'components/Loading/Loading';

import styles from './InfiniteLoader.module.scss';

export type InfiniteLoaderProps = {
  loading?: boolean,
  onRequestMoreItems: () => Promise<void> | void,
};

@observer
export default class InfiniteLoader extends React.Component<InfiniteLoaderProps> {
  scrollElement: ?HTMLElement = null;

  visitElement = React.createRef();
  scrollGuard = false;

  componentDidMount() {
    this.scrollElement = document.getElementById('content-section');

    if (this.scrollElement) {
      this.scrollElement.addEventListener('scroll', this.handleScroll);
    }
  }

  componentWillUnmount() {
    if (this.scrollElement) {
      this.scrollElement.removeEventListener('scroll', this.handleScroll);
    }
  }

  isElementInViewport = () => {
    if (this.scrollElement && this.visitElement.current) {
      const visitRect = this.visitElement.current.getBoundingClientRect();
      const containerRect = this.scrollElement.getBoundingClientRect();
      const containerBottom = containerRect.bottom;
      const containerRight = containerRect.right;
      const containerTop = 0;
      const containerLeft = 0;

      return (
        visitRect.top >= containerTop &&
        visitRect.left >= containerLeft &&
        visitRect.bottom <= containerBottom &&
        visitRect.right <= containerRight
      );
    }

    return false;
  };

  handleScroll = async () => {
    const { onRequestMoreItems } = this.props;

    if (!this.scrollGuard) {
      this.scrollGuard = true;

      if (this.isElementInViewport()) {
        await onRequestMoreItems();
      }

      this.scrollGuard = false;
    }
  };

  render() {
    const { children, loading } = this.props;

    return (
      <React.Fragment>
        {children}

        <div className={styles.infiniteLoader}>
          {loading && <Loading />}
          <div ref={this.visitElement} />
        </div>
      </React.Fragment>
    );
  }
}
